import { useParams, Link, Navigate } from "react-router-dom";
import { SERVICES } from "@/lib/content";
import { ArrowLeft, ArrowRight, Check } from "@phosphor-icons/react";

export default function ServiceDetail() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/services" replace />;
  const idx = SERVICES.findIndex(x=>x.slug===slug);
  const next = SERVICES[(idx+1) % SERVICES.length];

  return (
    <>
      <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <Link data-testid="back-services" to="/services" className="inline-flex items-center gap-2 font-mono-fine text-[11px] tracking-[0.24em] uppercase text-[var(--pta-navy)] hover:text-[var(--pta-gold)]"><ArrowLeft size={14} /> All Services</Link>
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8">
              <div className="chapter-num">Vertical {s.num}</div>
              <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">{s.title}.</h1>
              <p className="mt-8 font-serif-display italic text-2xl md:text-3xl text-[var(--pta-gold)]">{s.tagline}</p>
              <p className="mt-6 text-lg text-[var(--pta-ink)]/75 max-w-2xl">{s.for}</p>
            </div>
            <div className="lg:col-span-4">
              <div className="border hairline-navy p-6">
                <div className="overline">Engagement</div>
                <ol className="mt-4 space-y-3 text-sm text-[var(--pta-ink)]/80">
                  <li><span className="font-mono-fine text-[var(--pta-gold)] mr-2">01</span> Scoping call (30 min)</li>
                  <li><span className="font-mono-fine text-[var(--pta-gold)] mr-2">02</span> NDA + document review</li>
                  <li><span className="font-mono-fine text-[var(--pta-gold)] mr-2">03</span> Proposal with milestones</li>
                  <li><span className="font-mono-fine text-[var(--pta-gold)] mr-2">04</span> Kick-off & delivery</li>
                </ol>
                <Link data-testid="service-book" to="/book" className="btn-pta mt-6 w-full justify-center">Book Consultation</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[var(--pta-paper)] py-20">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="chapter-num">What's included</div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[var(--pta-navy)] mt-4">Deliverables & scope.</h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {s.items.map((it, i) => (
              <div key={i} className="flex items-start gap-3 border hairline bg-[var(--pta-cream)] p-4">
                <Check size={18} weight="bold" className="text-[var(--pta-gold)] mt-0.5 shrink-0" />
                <span className="text-[var(--pta-ink)]/85 text-sm">{it}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-dark py-20">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="chapter-num">Next</div>
            <Link data-testid="next-service" to={`/services/${next.slug}`} className="font-serif-display text-4xl md:text-6xl text-[var(--pta-cream)] hover:text-[var(--pta-gold)] block mt-3">{next.title} <ArrowRight className="inline" size={28} weight="bold" /></Link>
          </div>
          <Link to="/book" data-testid="service-cta" className="btn-pta-gold">Book Consultation</Link>
        </div>
      </section>
    </>
  );
}
